import { Button, CircularProgress } from '@mui/material';
import _ from 'lodash';
import { TitledPage } from '@client/new/components/Misc';
import { PrimaryButton } from '@client/new/components/button';
import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { useNewCreatorViewModel } from './newCreator.viewModel';
import { NewCreatorForm } from './NewCreatorForm';

export const NewCreator = () => {
  const viewModel = useNewCreatorViewModel();

  return (
    <AsyncRenderer
      data={viewModel}
      loadRender={
        <TitledPage title="New Creator">
          <div className="flex justify-center items-center">
            <CircularProgress />
          </div>
        </TitledPage>
      }
      renderer={(data) => (
        <TitledPage
          title="New Creator"
          rightContent={
            data ? (
              <div className="flex gap-4">
                <Button
                  onClick={() => data.dispatch({ type: 'cancel' })}
                  className="h-[40px]"
                >
                  Cancel
                </Button>
                <PrimaryButton
                  onClick={() => data.dispatch({ type: 'submit' })}
                  className="h-[40px] min-w-[100px]"
                  disabled={data.submitting}
                  id="save-btn"
                >
                  Save
                </PrimaryButton>
              </div>
            ) : null
          }
        >
          <NewCreatorForm {...data} />
        </TitledPage>
      )}
    />
  );
};
